/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// likbraries
import React from 'react';
// material
import { Tip } from '@insticator/insticator-ui'; // iui-material
// utils
import { generateClasses } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'material/callout/datalastupdated/datalastupdated_styles';



/* ========== ~~~~~~~~~~ CALLOUT : DATA LAST UPDATED ~~~~~~~~~~ ========== */
const DataLastUpdated = (props) => {
	const applyDataMessages = () => {
		const messages = [
			`Data is updated daily at approx. 4pm EST.`,
			'All data displayed and available is in EST time zone.',
			'All report data is finalized for billing after the 7th day of the following month.'
		];
		return (
			<div className={'list'}>
				{messages.map(message => <div className={'listitem'}><i className="fas fa-check"></i><span className={'text'}>{message}</span></div>)}
			</div>
		);
	}
	return (
		<div className={`callout datalastupdated ${generateClasses(props)} ${props.classes.datalastupdated}`}>
			<p>About reporting data accuracy <Tip space={`none`} content={applyDataMessages()} /></p>
        </div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(DataLastUpdated);
